import { getSafeUrl } from "../../../utils/helpers.js";
import { Fragment, useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "axios";

import { useUserDispatch, useUserState } from "../../../Contexts/UserContext";

import Approve from "../../../assets/images/Approve.svg";
import aboutUs from "../../../assets/images/about-us.png";
import tickmark from "../../../assets/images/tickmark.svg";
import furnitureBanner from "../../../assets/images/furniture-banner.png";
import FurnitureBackImg from "../../../assets/images/furniture-back.png";

import "react-datepicker/dist/react-datepicker.css";
import "./CustomiseFurniture.css";
import PackageSummaryModal from "./FurniturePackageTotal";
import { set } from "store";

const CustomisePlan = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useUserState();
  const dispatch = useUserDispatch();
  const [furCompaniesList, setFurCompaniesList] = useState([]);

  const [companySelectedStatus, setCompanySelectedStatus] = useState(false);
  const [companyListLoader, setCompanyListLoader] = useState(false);
  const [furList, setFurList] = useState([]);
  const [housewareItems, setHousewareItems] = useState([]);
  const [furListLoader, setFurListLoader] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [companyId, setCompanyId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [furDetailModal, setFurDetailModal] = useState(false);
  const [particularFurInfo, setParticularFurInfo] = useState({});
  const [loader, setLoader] = useState(false);
  const [clickHereLoader, setClickHereLoader] = useState(false);
  const [selectedFurDetail, setSelectedFurDetail] = useState({});
  const [houseDetail, setHouseDetail] = useState({});
  const [deliveryPrice, setDeliveryPrice] = useState(0);
  const [negotiationPeriod, setNegotiationPeriod] = useState({
    month: 0,
    days: 0,
  });
  const [openPackageDetailModal, setOpenPackageDetailModal] = useState(false);
  const headers = {
    Authorization: user?.token,
  };
 // set delivery price
 useEffect(()=>{
  const deliveryPrice = furCompaniesList?.filter((item)=> item?.id === companyId);
  setDeliveryPrice(deliveryPrice[0]?.furniture_delivery_price + deliveryPrice[0]?.city_extra_price)
 },[furCompaniesList])
  
  // console.log('allFurPkgCart',allFurPkgCart);
  
  // const fetchCompaniesList = async () => {
  //   const apiUrl = `${
  //     import.meta.env.VITE_APP_BASE_URL
  //   }/api/user/getAllCompany/furniture_company?categoryId=${
  //     location?.state?.furPlanId
  //   }&&houseId=${location?.state?.houseId}`;
  //   setCompanyListLoader(true);
  //   try {
  //     const res = await axios.get(apiUrl, {
  //       headers: headers,
  //     });
  //     setFurCompaniesList(
  //       res?.data?.data?.filter((item) => item.totalPrice > 0)
  //     );
  //     setCompanyListLoader(false);
  //   } catch (error) {
  //     console.log(
  //       "Error while fetching furniture company List",
  //       error?.message
  //     );
  //     setCompanyListLoader(false);
  //   }
  // };

  const fetchHouseDetail = async () => {
    const apiUrl = `${import.meta.env.VITE_APP_BASE_URL}/api/house/get/${location?.state?.houseId
      }`;
    try {
      const res = await axios.get(apiUrl, { headers });
      setHouseDetail(res?.data?.data);
    } catch (error) {
      console.log(
        "Error while fetching furniture company list",
        error?.message
      );
    }
  };
  useEffect(() => {
    fetchHouseDetail(location?.state?.houseId);
  }, [location?.state?.houseId, user?.token]);
  const fetchCompaniesList = async () => {
    const apiUrl = `${import.meta.env.VITE_APP_BASE_URL
      }/api/user/getAllCompany/furniture_company?categoryId=${location?.state?.furPlanId
      }&&houseId=${location?.state?.houseId}&&furniture_type=${location?.state?.furPlanId
      }`;
    try {
      const res = await axios.get(apiUrl, { headers });
      const filteredCompanies =
        res?.data?.data?.filter((item) => item.totalPrice > 0) || [];

      // if (filteredCompanies.length === 0) {
      //   // redirect if no companies
      //   navigate(
      //     `/cleaning-package?cart=${location?.state?.cartId}&&house=${location?.state?.houseId}`,
      //     {
      //       state: {
      //         houseId: location?.state?.houseId,
      //         cartId: location?.state?.cartId,
      //         startDate: location?.state?.startDate,
      //         endDate: location?.state?.endDate,
      //         storeId: storeId,
      //       },
      //     }
      //   );
      //   return; // stop function here
      // }

      setFurCompaniesList(res?.data?.data);
    } catch (error) {
      console.log(
        "Error while fetching furniture company list",
        error?.message
      );
    }
  };
  // const handleChooseCompany = async (id) => {
  //   debugger
  //    const leasperiod = normalizeLeasePeriod(
  //     location.state.negotiationPeriod.month,
  //     location.state.negotiationPeriod.days
  //   );
  //   setSelectedOption(id);
  //   const apiUrl = `${
  //     import.meta.env.VITE_APP_BASE_URL
  //   }/api/furniture/get-list?categoryId=${
  //     location?.state?.furPlanId
  //   }&companyId=${id}&leasePeriod=${leasperiod}&bedroom=${houseDetail?.bedroom_no}&bathroom=${houseDetail?.bathroom_no}`;
  //   setFurListLoader(true);
  //   try {
  //     const res = await axios.get(apiUrl, {
  //       headers: headers,
  //     });
  //     fetchAllfurnitureList(id, res?.data?.data);
  //   } catch (error) {
  //     console.error(
  //       "Error while fetching furniture on behalf of company:",
  //       error?.message
  //     );
  //     setFurListLoader(false);
  //   }
  // };
  const normalizeLeasePeriod = (months, days) => {
    // Convert extra days into months if >= 15 days
    if (days >= 15) {
      months += 1;
    }

    let normalizedLeasePeriod;
    if (months >= 1 && months <= 3) {
      normalizedLeasePeriod = 3;
    } else if (months >= 4 && months <= 6) {
      normalizedLeasePeriod = 6;
    } else if (months >= 7) {
      normalizedLeasePeriod = 12;
    } else {
      normalizedLeasePeriod = 0;
    }

    return normalizedLeasePeriod;
  };


  const addTwoDays = (date) => {
    if (date) {
      date.setDate(date.getDate() + 2); // Add two days
      return date.toLocaleDateString("en-US");
    }
  };

  const handleProceed = async () => {
    //debugger
    const finalArray = [];
    let allFurPkgCart = [...furList, ...housewareItems];
    if (furList?.length > 0) {
      for (let i = 0; i < allFurPkgCart.length; i++) {
        const element = allFurPkgCart[i];
        const newObj = {
          furniture_category_id: element.furniture_category_id,
          house_id: location?.state?.houseId,
          furniture_id: element?.id,
          quantity: element?.quantity,
          is_package_item: true,
        };
        finalArray.push(newObj);
      }
    }
    let payload = {
      cartId: location?.state?.cartId,
      furData: finalArray,
      dataType: "furniture",
    };

    const apiUrl = `${import.meta.env.VITE_APP_BASE_URL}/api/cart/update-cart/${location?.state?.cartId
      }`;

    setLoader(true);
    try {
      const res = await axios.put(apiUrl, payload, {
        headers: headers,
      });
      setLoader(false);
      if (res?.data?.statusCode === 200) {
        dispatch({
          type: "SET_SELECTED_FURNITURE_DETAIL",
          payload: { selectedFurDetail },
        });
        navigate(
          `/cleaning-package?cart=${location?.state?.cartId}&&house=${location?.state?.houseId}`,
          {
            state: {
              houseId: location?.state?.houseId,
              cartId: location?.state?.cartId,
              startDate: location?.state?.startDate,
              endDate: location?.state?.endDate,
              storeId: storeId,
            },
          }
        );
      }
    } catch (error) {
      setLoader(false);
      console.log("Error while hitting update cart API", error);
    }
  };

  const clickHereCustomize = async () => {
    setClickHereLoader(true);
    try {
      await axios.delete(
        `${import.meta.env.VITE_APP_BASE_URL}/api/cart/remove-by-carttype`,
        {
          data: {
            dataType: "furniture",
            house_id: location?.state?.houseId,
          },
          headers: headers,
        }
      );
      setClickHereLoader(false);
        const finalArray = [];
    let allFurPkgCart = [...furList, ...housewareItems];
    if (furList?.length > 0) {
      for (let i = 0; i < allFurPkgCart.length; i++) {
        const element = allFurPkgCart[i];
        const newObj = {
          furniture_category_id: element.furniture_category_id,
          house_id: location?.state?.houseId,
          furniture_id: element?.id,
          quantity: element?.quantity,
          is_package_item: true,
        };
        finalArray.push(newObj);
      }
    }
      navigate(`/customise-furniture`, {
        state: {
          houseId: location?.state?.houseId,
          cartId: location?.state?.cartId,
          furPlan: location?.state?.furPlan,
          furPlanId: location?.state?.furPlanId,
          companyId: companyId,
          startDate: location?.state?.startDate,
          endDate: location?.state?.endDate,
          storeId: storeId,
          houseDetail: houseDetail,
          allFurPkgCart: finalArray,
          housewareItems: housewareItems,
          furList: furList,
          deliveryPrice: deliveryPrice,
        },
      });
    } catch (error) {
      console.log("Error while hitting remove cart API", error?.message);
      setClickHereLoader(false);
    }
  };
  function calculateDateDifference(startDate, endDate) {
    // Calculate the difference in milliseconds
    const differenceMs = endDate - startDate;

    // Convert milliseconds to days, adding 1 to include both start and end dates
    const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24)) + 1;

    // Calculate months and remaining days
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();

    let diffYear = endDate.getFullYear() - startDate.getFullYear();
    let diffMonth = endDate.getMonth() - startDate.getMonth();
    let months = diffYear * 12 + diffMonth;
    if (months < 0 || (months === 0 && endDay < startDay)) {
      months += 12;
    }
    let remainingDays = endDay - startDay + 1;
    if (
      remainingDays ===
      new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0).getDate()
    ) {
      months++, (remainingDays = 0);
    }
    if (remainingDays < 0) {
      months--;
      const tempDate = new Date(endDate);
      tempDate.setMonth(endDate.getMonth() - 1);
      remainingDays =
        new Date(tempDate.getFullYear(), tempDate.getMonth() + 1, 0).getDate() -
        startDay +
        endDay +
        1;
    }

    return {
      days: differenceDays,
      months: months,
      remainingDays: remainingDays,
    };
  }
  const handleChooseCompany = async (id, storeId, leasePeriodOverride) => {
    setFurListLoader(true);

    // use passed leasePeriod if available, else fallback to state
    const leasePeriod = leasePeriodOverride || negotiationPeriod;
    const leasperiod = normalizeLeasePeriod(leasePeriod.month, leasePeriod.days);

    setCompanyId(id);
    setStoreId(storeId);
    setCompanySelectedStatus(true);

    if (leasperiod > 0) {
      const apiUrl = `${import.meta.env.VITE_APP_BASE_URL}/api/furniture/get-list?categoryId=${location?.state?.furPlanId}&companyId=${id}&leasePeriod=${leasperiod}&bedroom=${houseDetail?.bedroom_no}&bathroom=${houseDetail?.bathroom_no}`;

      try {
        const res = await axios.get(apiUrl, { headers });
        const furniturePackageAllData = res?.data?.data || [];

        const { houseWarePackage, furnitureData } = furniturePackageAllData?.reduce(
          (acc, item) => {
            if (item.type?.toLowerCase() === "houseware") acc.houseWarePackage.push(item);
            else acc.furnitureData.push(item);
            return acc;
          },
          { houseWarePackage: [], furnitureData: [] }
        );
        setFurList(furnitureData);
        setHousewareItems(houseWarePackage);

        const selectedCompany = furCompaniesList?.find((item) => item?.id === id);
        if (selectedCompany) {
          setSelectedFurDetail(selectedCompany);
        }
        const sum = furnitureData.reduce(
          (acc, item) => acc + (parseInt(item.price || 0, 10) * (item.quantity || 1)),
          0
        );
        setTotalPrice(sum);

      //  setTotalPrice(sum);
      } catch (error) {
        console.error("Error while fetching furniture:", error.message);
      } finally {
        setFurListLoader(false);
      }
    } else {
      setFurListLoader(false);
    }
  };

  const negotiationDetail = async (negoId) => {
    const headerJson = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    setFurListLoader(true);

    try {
      const negoDetails = await axios.get(
        `${import.meta.env.VITE_APP_BASE_URL
        }/api/house-negotiate-history/get/${negoId}`,
        { headers: headerJson }
      );

      const data = negoDetails.data.data;

      const startDate = data?.owner_offered_lease_start_date
        ? new Date(data.owner_offered_lease_start_date)
        : new Date(data.cust_offered_lease_start_date);

      const endDate = data?.owner_offered_lease_end_date
        ? new Date(data.owner_offered_lease_end_date)
        : new Date(data.cust_offered_lease_end_date);

      let { months, remainingDays } = calculateDateDifference(
        startDate,
        endDate
      );

      // set state for UI
      setNegotiationPeriod({ month: months, days: remainingDays });

      // ✅ call API with fresh values (not waiting for setState)
      if (months !== 0 || remainingDays !== 0) {
        handleChooseCompany(location.state.companyId, location.state.storeId, {
          month: months,
          days: remainingDays,
        });
      }
    } catch (error) {
      console.error("Error fetching negotiation details:", error.message);
      setFurListLoader(false);
    }
  };
  useEffect(() => {
    if (negotiationPeriod.month !== 0 || negotiationPeriod.days !== 0) {
      handleChooseCompany(location.state.companyId, location.state.storeId);
    }
  }, [negotiationPeriod, location.state.companyId, location.state.storeId]);

  useEffect(() => {
    negotiationDetail(location.state.negotiationPeriod);
  }, [location.state.companyId, houseDetail]);

  useEffect(() => {
    if (user?.token) {
      fetchCompaniesList();
    }
    if (
      !location?.state?.houseId ||
      !location?.state?.cartId ||
      !location?.state?.startDate ||
      !location?.state?.endDate ||
      !location?.state?.furPlanId ||
      !location?.state?.furPlan
    ) {
      navigate("/");
    }
  }, [user?.token]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);
  const NavigateToCleaning = () => {
    navigate(
      `/cleaning-package?cart=${location?.state?.cartId}&&house=${location?.state?.houseId}`,
      {
        state: {
          houseId: location?.state?.houseId,
          cartId: location?.state?.cartId,
          startDate: location?.state?.startDate,
          endDate: location?.state?.endDate,
          storeId: storeId,
        },
      }
    );
  };
  return (
    <Fragment>
      <div className="banner-section furniture-main">
        <img src={furnitureBanner} alt="furnitureBanner" />
        <div className="search-home my-container">
          <div className="furniture-about">
            <div className="furniture-img">
              <img src={aboutUs} />
            </div>
            <div className="fur-about-content">
              <h2>Quality Furniture Store On Your Specific Area</h2>
              <p>
                We build and activate brands through cultural insight,
                strvision, and the power of emotion across every.
              </p>
              <div className="overview-amenities">
                <ul>
                  <li>
                    <img src={tickmark} />
                    Mix and match colors, sizes, and designs
                  </li>
                  <li>
                    <img src={tickmark} />
                    Top quality prints using the latest technology
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* <div className="negotiate-content">
            <h3>
              {location?.state?.furPlan} Package Offer from different trusted
              partners
            </h3>
            <div className="row">
              {companyListLoader && (
                <div className="sap-loader-onscreen">
                  <div className="eye-loader-frame m-5 p-5">
                    <div className="eye-loader-spinner"></div>
                  </div>
                </div>
              )}
              {furCompaniesList &&
                furCompaniesList?.length > 0 &&
                furCompaniesList?.map((company) => (
                  <div
                    key={company?.companyId}
                    className={`col-12 col-lg-3 col-md-3 ${
                      storeId === company?.companyId ? "active-company" : ""
                    }`}
                  >
                    <div className="trusted-part-title">
                      <h2>{company?.furniture_company}</h2>
                    </div>
                    <div className="trusted-part-radio">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="default"
                          id={company?.companyId}
                          onChange={() => {
                            handleChooseCompany(
                              company?.id,
                              company?.companyId
                            );
                          }}
                        />\
                        <label
                          className="form-check-label"
                          htmlFor={company?.companyId}
                        />
                      </div>
                      <div className="furniture-new-price-del">
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div> */}
        </div>
      </div>
      {companySelectedStatus && (
        <>
          <div className="dilivery-time-sec">
            <div className="container-fluid my-container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="search-header">
                    <h2>Your Delivery Date & Time</h2>
                    <p>
                      <i className="fa fa-info" aria-hidden="true"></i>{" "}
                      Furniture will be delivered on{" "}
                      {addTwoDays(new Date(location?.state?.startDate))}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="furniture-plan delux">
            <div className="container-fluid my-container">
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9">
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="search-header">
                        <h2>{location?.state?.furPlan} Package</h2>
                        <div className="sel_pac">
                          <h4>
                            Total - <span>${totalPrice}</span>
                          </h4>
                        </div>
                      </div>
                    </div>
                    {furListLoader ? (
                      <div className="sap-loader-onscreen">
                        <Spinner />
                      </div>
                    ) : furCompaniesList?.length > 0 && furList && furList.length > 0 ? (
                      furList.map((fur) => (
                        <div
                          key={fur?.id}
                          className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4"
                        >
                          <div className="property-inner furniture-custom">
                            <div className="custom-fur-img">
                              <a
                                className="btn btn-primary"
                                onClick={() => {
                                  setFurDetailModal(true);
                                  setParticularFurInfo(fur);
                                }}
                              >
                                <i
                                  className="fa fa-info"
                                  aria-hidden="true"
                                ></i>
                              </a>
                              <img
                                src={
                                  getSafeUrl(fur?.imageUrl)
                                }
                                alt={fur?.name}
                                onError={(e) => {
                                  e.target.src = FurnitureBackImg;
                                }}
                              />
                            </div>
                            <div className="custom-fur-content">
                              <h4>{fur?.name}</h4>
                              {/* <p className="price-sec">${fur?.price}</p> */}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div>
                        <h5>No furniture for this house </h5>
                        <div
                          className="property-content"
                          onClick={() => NavigateToCleaning()}
                        >
                          <div className="property-discription">
                            <a>Skip</a>
                          </div>
                        </div>
                      </div>
                    )}

                    {!furListLoader && furList.length > 0 && (
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="sap_prem_btn cleaning">
                          <button type="button" onClick={() => navigate(-1)}>
                            Go Back
                          </button>
                          <button
                            type="button"
                            disabled={loader}
                            onClick={() => setOpenPackageDetailModal(true)}
                          >
                            Proceed {loader && <Spinner />}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3">
                  <div className="customise-package-sec">
                    <div className="custom-contetn">
                      <h4>Modify Your Package?</h4>
                      <Button
                        disabled={clickHereLoader}
                        onClick={() => {
                          clickHereCustomize();
                        }}
                      >
                        Click Here! {clickHereLoader && <Spinner />}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    <PackageSummaryModal
        open={openPackageDetailModal}
        onClose={() => setOpenPackageDetailModal(false)}
        onProceed={handleProceed}
        furniture={furList}
        houseware={housewareItems}
        deliveryPrice={deliveryPrice}
        packageName={location?.state?.furPlan}
      />

      <Modal
        size="lg"
        show={furDetailModal}
        onHide={() => setFurDetailModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="negotiate-content">
            <div className="container">
              <div className="row">
                <div className="col-12 col-lg-4 col-md-4">
                  <img
                    src={
                      getSafeUrl(particularFurInfo?.imageUrl)
                    }
                    onError={(e) => {
                      e.target.src = FurnitureBackImg;
                    }}
                  />
                </div>
                <div className="col-12 col-lg-8 col-md-8">
                  <div className="furniture-content">
                    <h3>{particularFurInfo?.name}</h3>
                    <p className="furn-price">${particularFurInfo?.price} </p>
                    <div className="furniture-content Specific">
                      <h3>Specifications</h3>
                      <ul>
                        <li>
                          <img
                            src={Approve}
                            onError={(e) => {
                              e.target.src = FurnitureBackImg;
                            }}
                          />
                          <div className="Specific-content">
                            <h3>Brand Name</h3>
                            <p>{particularFurInfo?.brand}</p>
                          </div>
                        </li>
                        <li>
                          <img
                            src={Approve}
                            onError={(e) => {
                              e.target.src = FurnitureBackImg;
                            }}
                          />
                          <div className="Specific-content">
                            <h3>Color</h3>
                            <span
                              className="color-swatch"
                              style={{
                                background: `${particularFurInfo?.color}`,
                              }}
                            ></span>
                          </div>
                        </li>
                        <li>
                          <img
                            src={Approve}
                            onError={(e) => {
                              e.target.src = FurnitureBackImg;
                            }}
                          />
                          <div className="Specific-content">
                            <h3>Material</h3>
                            <p>{particularFurInfo?.material}</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-12 col-md-12">
                  <div className="furniture-content dicription">
                    <h3>Description</h3>
                    <p>{particularFurInfo?.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default CustomisePlan;
